import React from "react";
import EditArtistSocial from "../components/EditArtistSocial";

const EditArtistSocialApp = (props) => <EditArtistSocial {...props} />;

export default EditArtistSocialApp;
